import {CreateSlice} from 'base'

type ModalOpenKeyType = '1st' | '2nd' | null
export interface RequestsSlice {
  newRequest: any
  isManagerAssignOpen: boolean
  isLoanOpen: boolean
  isForecastOpen: boolean
  isVariationForecastOpen: boolean
  variationEstablishmentFeeOpenKey: ModalOpenKeyType
  variationLineFeeOpenKey: ModalOpenKeyType
  variationFacilityLimit2OpenKey: ModalOpenKeyType
  isVariationJournalEntry2Open: boolean
  isVariationDataConfirmOpen: boolean
  isSecurityItemsOpen: boolean
  forecastCreatedProjects: string[]
  isControllerReviewOpen: boolean
  isOfferOpen: boolean
  isAMLBeneficiaryOpen: boolean
  isBorrowerAssignOpen: boolean

  setNewRequest: (newRequest: any) => void
  setManagerAssignOpen: (isManagerAssignOpen: boolean) => void
  setLoanOpen: (isLoanOpen: boolean) => void
  setForecastOpen: (isForecastOpen: boolean) => void
  setVariationForecastOpen: (isVariationForecastOpen: boolean) => void
  setVariationEstablishmentFeeOpenKey: (key: ModalOpenKeyType) => void
  setVariationLineFeeOpenKey: (key: ModalOpenKeyType) => void
  setVariationFacilityLimit2OpenKey: (key: ModalOpenKeyType) => void
  setVariationJournalEntry2Open: (isVariationJournalEntry2Open: boolean) => void
  setVariationDataConfirmOpen: (isVariationDataConfirmOpen: boolean) => void
  setSecurityItemsOpen: (isForecastOpen: boolean) => void
  setForecastCreatedProjects: (projectUuid: string) => void
  setControllerReviewOpen: (isControllerReviewOpen: boolean) => void
  setOfferOpen: (isOfferOpen: boolean) => void
  setAMLBeneficiaryOpen: (isAMLBeneficiaryOpen: boolean) => void
  setBorrowerAssignOpen: (isBorrowerAssignOpen: boolean) => void
}

const createRequestsSlice: CreateSlice<RequestsSlice> = (set) => ({
  newRequest: {},
  isManagerAssignOpen: false,
  isLoanOpen: false,
  isForecastOpen: false,
  isVariationForecastOpen: false,
  variationEstablishmentFeeOpenKey: null,
  variationLineFeeOpenKey: null,
  variationFacilityLimit2OpenKey: null,
  isVariationJournalEntry2Open: false,
  isVariationDataConfirmOpen: false,
  isSecurityItemsOpen: false,
  forecastCreatedProjects: [],
  isControllerReviewOpen: false,
  isOfferOpen: false,
  isAMLBeneficiaryOpen: false,
  isBorrowerAssignOpen: false,

  setNewRequest: (newRequest) => set(() => ({newRequest})),
  setManagerAssignOpen: (isManagerAssignOpen) =>
    set(() => ({isManagerAssignOpen})),
  setLoanOpen: (isLoanOpen) => set(() => ({isLoanOpen})),
  setForecastOpen: (isForecastOpen) => set(() => ({isForecastOpen})),
  setVariationForecastOpen: (isVariationForecastOpen) => set(() => ({isVariationForecastOpen})),
  setVariationEstablishmentFeeOpenKey: (key: ModalOpenKeyType) => set(() => ({variationEstablishmentFeeOpenKey: key})),
  setVariationLineFeeOpenKey: (key: ModalOpenKeyType) => set(() => ({variationLineFeeOpenKey: key})),
  setVariationFacilityLimit2OpenKey: (key: ModalOpenKeyType) => set(() => ({variationFacilityLimit2OpenKey: key})),
  setVariationDataConfirmOpen: (isVariationDataConfirmOpen: boolean) => set(() => ({isVariationDataConfirmOpen})),
  setVariationJournalEntry2Open: (isVariationJournalEntry2Open: boolean) => set(() => ({isVariationJournalEntry2Open})),
  setSecurityItemsOpen: (isSecurityItemsOpen) =>
    set(() => ({isSecurityItemsOpen})),
  setForecastCreatedProjects: (projectUuid) =>
    set((state) => ({
      forecastCreatedProjects: [...state.forecastCreatedProjects, projectUuid],
    })),
  setControllerReviewOpen: (isControllerReviewOpen) =>
    set(() => ({isControllerReviewOpen})),
  setOfferOpen: (isOfferOpen) => set(() => ({isOfferOpen})),
  setAMLBeneficiaryOpen: (isAMLBeneficiaryOpen) =>
    set(() => ({isAMLBeneficiaryOpen})),
  setBorrowerAssignOpen: (isBorrowerAssignOpen) =>
    set(() => ({isBorrowerAssignOpen})),
})

export default createRequestsSlice
